@if (tabs.length > 0) {
  <div class="node-detail-popover_details" data-testid="node-details-popover_container">
    <div class="node-detail-popover_details-title">{{ data.nodeTitle }}</div>
    <nav class="node-detail-popover_nav">
      @for (tab of tabs; track tab) {
        <span
          class="node-detail-popover_nav-button"
          [class.node-detail-popover_nav-button--selected]="selectedTab() === tab"
          (click)="onTabSwitch(tab)">
          <button>
            {{ 'Flowchart.NodeDetailDialog.' + tab + '.Title' | transloco }}
          </button>
          @if ((tab === NodeDetailPopoverTab.ATTACHMENTS || tab === NodeDetailPopoverTab.LINKS) && data[tab.toLowerCase()].length > 1) {
            <span class="node-detail-popover_nav-count">
              {{ data[tab.toLowerCase()].length }}
            </span>
          }
        </span>
      }
    </nav>
    <div class="node-detail-popover_content treetop-scroll">
      @switch (selectedTab()) {
        @case (NodeDetailPopoverTab.DESCRIPTION) {
          <tt-node-detail-popover-description [description]="data.description" />
        }
        @case (NodeDetailPopoverTab.ATTACHMENTS) {
          <tt-node-detail-popover-attachments
            [attachments]="data.attachments"
            [deletedOriginalAttachmentIds]="data.deletedOriginalAttachmentIds"
            [isEditImportedMode]="data.isEditImportedMode"
            [localAttachments]="data.localAttachments" />
        }
        @case (NodeDetailPopoverTab.LINKS) {
          <tt-node-detail-popover-links
            [isPreviewMode]="data.isPreviewMode"
            [isPublicPage]="data.isPublicPage"
            [isUpdateReviewMode]="data.isUpdateReviewMode"
            [links]="data.links" />
        }
        @case (NodeDetailPopoverTab.MEDICATIONS) {
          <tt-node-detail-popover-medications [medications]="data.medications" />
        }
        @case (NodeDetailPopoverTab.REFERENCES) {
          <tt-node-detail-popover-references [references]="data.references" />
        }
      }
    </div>
  </div>
}
